export default {
    flexMain: {
        flex: "0 0 60%"
    } as React.CSSProperties,
    flexColumns: {
        display: "flex",
        flexDirection: "column"
    } as React.CSSProperties,
    flexRows: {
        display: "flex",
        flexDirection: "row"
    } as React.CSSProperties,
    flexFill: {
        flex: "1 1 100%"
    } as React.CSSProperties,
    flexAuto: {
        flex: "0 0 auto"
    } as React.CSSProperties,
};